module.exports = __webpack_public_path__ + "MHIECE_logo.21836ce9e8533cbd6d3b91cabd7f4a26.png";